import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import styles from './Checkbox.module.scss';
import {
  billingAddressOptions,
} from '../../../slices/billingAddress';

const Checkbox = ({
  id,
  name,
  label,
  labelText,
  onChange,
  onBlur,
  checked,
  disabled,
  isRound,
  dataTestId
}) => (
  <div className={styles['form-group']}>
    <input
      id={id}
      // Just to ensure that the DOM element is re-rendered when we go back and forth in the page
      // We are not using this conponent on any html form so this doesn't have any negative impact.
      name={name + Math.random().toString()}
      type="checkbox"
      onChange={onChange}
      disabled={disabled}
      onBlur={onBlur}
      checked={checked}
      data-testid={dataTestId}
    />
    <label htmlFor={id} data-testid="checkbox-label" className={classnames({
      [styles.mb]: dataTestId === billingAddressOptions.same && !checked
    })}>
      <div
        className={classnames(styles['check-mark'], { [styles['is-circle']]: isRound })}
        onKeyDown={(e) => {
          if (e.key === 'Enter') {
            document.getElementById(id).click();
          }
        }}
        aria-label={labelText || label}
        aria-checked={checked}
        role="checkbox"
        tabIndex="0"
      />
      <div className={styles.label}>{label}</div>
    </label>
  </div>
);

Checkbox.propTypes = {
  id: PropTypes.string,
  name: PropTypes.string.isRequired,
  checked: PropTypes.bool.isRequired,
  label: PropTypes.node,
  labelText: PropTypes.string,
  onChange: PropTypes.func,
  onBlur: PropTypes.func,
  disabled: PropTypes.bool,
  isRound: PropTypes.bool,
  dataTestId: PropTypes.string,
};

Checkbox.defaultProps = {
  id: '',
  label: '',
  onChange: () => {},
  onBlur: () => {},
  disabled: false,
  isRound: false,
  labelText: '',
  dataTestId: 'checkbox-input'
};

export default Checkbox;
